{
  "locale": "de-DE",
  "mobile": {
    "share": "Teilen"
  },
  "cart": {
    "engraving-line-1": "Gravur Zeile 1",
    "engraving-line-2": "Gravur Zeile 2",
    "key-number": "Schlüsselnummer",
    "item-number-short": "Art. Nr.",
    "whatever": "beliebig",
    "subtotal": "Zwischensumme",
    "shipping": "Versand",
    "shipping-costs": "Versandkosten",
    "less-30eur-order-value": "unter 30 € Bestellwert",
    "without-vat-short": "exkl. MwSt.",
    "with-percent-vat-short": "inkl. {percent}% MwSt.",
    "total": "Gesamt",
    "dealer-conditions-info": "Bitte beachten Sie, dass Ihre bekannten Konditionen erst auf der Rechnung ausgewiesen werden.",
    "checkout now": "Jetzt zur Kasse",
    "cart-is-empty": "Der Warenkorb ist momentan leer.",
    "shopping-now": "Jetzt einkaufen »",
    "remove": "löschen",
    "close-cart": "Warenkorb schließen",
    "continue_shopping": "Weiter einkaufen",
    "packaging": "Verpackungskosten",
    "engraving-line-3": "Gravur Zeile 3"
  },
  "overlay": {
    "close": "schließen"
  },
  "dealer-login": {
    "headline": "Händler Login",
    "logged-in-info-html": "Sie sind eingeloggt mit der Händlernummer <b>{number}</b>.",
    "logout": "Ausloggen",
    "dealer-number": "Zugangskennung",
    "error": "Es ist ein Fehler aufgetreten! Bitte versuchen Sie es später erneut.",
    "invalid-login": "ungültiger Login",
    "login": "Einloggen",
    "prompt": "Geben Sie Ihre Händlernummer und Postleitzahl ein oder verwenden Sie Ihre eInfo-Zugangsdaten, um sich einzuloggen.<br><br>Bitte beachten Sie, dass der Login mit Händlernummer und PLZ in naher Zukunft nicht mehr möglich sein wird.<br><br>Benutzen Sie den folgenden <a href=\"https://einfo.renzgroup.com/de/account-request\">Link</a>, um einen eInfo-Zugang zu beantragen.<br><br>",
    "problem-contact-html": "Bei Problemen wenden Sie sich an:<br /><a href=\"mailto:service@renz24.de\">service@renz24.de</a>",
    "password": "Passwort",
    "forgot-password": "Passwort vergessen?",
    "mfa-code": "Code",
    "mfa-info": "An Ihre Email-Adresse wurde ein Code zugesendet. Bitte geben Sie diesen hier zur Bestätigung ein."
  },
  "footer": {
    "overview": "Übersicht",
    "shop-service": "Shop Service",
    "contact": "Kontaktinfos",
    "social-media": "Soziale Medien",
    "sustainability": "Nachhaltigkeit",
    "sustainability-text": "RENZ setzt vollständig auf Ökostrom.",
    "we-ship-with": "Wir versenden mit"
  },
  "header": {
    "menu": "Menü",
    "service-area": "Servicebereich",
    "my-orders": "Meine Bestellungen",
    "login": "Login",
    "logout": "Logout",
    "back": "zurück",
    "purchase-on-account": "Kauf auf Rechnung",
    "short-delivery-time": "Kurze Lieferzeit",
    "secure-payment": "Sichere Zahlung"
  },
  "properties": {
    "free-shipping": "Versandkostenfrei ab 30 Euro (in DE)",
    "quick-delivery": "Kurze Lieferzeiten",
    "secure-payment": "Sichere Zahlung",
    "uncomplicated-purchase": "Unkomplizierte Bezahlung",
    "purchase-on-account": "Kauf auf Rechnung"
  },
  "mobile-search": {
    "headline": "Shop durchsuchen",
    "placeholder": "Artikelname oder Artikelnummer"
  },
  "site-nav": {
    "all-products": "Alle Produkte"
  },
  "econfig-teaser": {
    "to-configurator": "zum Konfigurator",
    "to-products": "zu den Produkten"
  },
  "options": {
    "headline": "Optionen",
    "confirm-selection": "Auswahl bestätigen"
  },
  "inquiry": {
    "error-alert": "Es ist ein Fehler aufgetreten. Die Anfrage wurde nicht verarbeitet. Bitte versuchen Sie es später erneut.",
    "headline": "Anfrage stellen",
    "success": "Vielen Dank für Ihre Anfrage!",
    "success-headline-offer-assistant": "Ihre Anfrage wurde weitergeleitet",
    "success-offer-assistant": "Ihre Anfrage wurde an den von Ihnen ausgewählten Händler zur Bearbeitung weitergeleitet.",
    "firstname": "Vorname",
    "optional": "optional",
    "lastname": "Nachname",
    "company": "Unternehmen",
    "street": "Straße",
    "house-number": "Hausnummer",
    "country": "Land",
    "default-country": "Deutschland",
    "postcode": "PLZ",
    "city": "Ort",
    "email": "E-Mail",
    "phone": "Telefonnummer",
    "phone-tooltip": "Die Telefonummer wird bei Bedarf an die Spedition weitergegeben.",
    "commission": "Kommission",
    "construction-project": "Bauvorhaben",
    "special-request": "Sonderwunsch",
    "special-request-placeholder": "Mit Eingabe eines Sonderwunsch kann dieses Angebot nicht mehr automatisch erzeugt werden. Ein Händler wird sich dann in den nächsten Tagen mit Ihnen in Verbindung setzen.",
    "special-request-placeholder-iframe": "Gerne nehmen wir Ihren Sonderwunsch entgegen und werden diesen schnellstmöglich bearbeiten.",
    "dealer-choice-intro": "Bitte wählen Sie nachfolgend einen Fachhändler aus. Nach dem Absenden erhalten Sie innerhalb der nächsten Minuten ein unverbindliches Angebot.",
    "dealer-choice-prompt": "Wählen Sie einen Fachhändler aus",
    "local-dealer": "Regionaler Fachhändler",
    "please-choose": "Bitte wählen Sie aus",
    "within-radius-of": "im Umkreis von",
    "no-dealer-within-radius": "Es wurden keine Händler im Umkreis gefunden!",
    "no-dealer-for-postcode": "Die Suche ergab zur angegebenen Postleitzahl keine Treffer!",
    "or": "oder",
    "renz-online-partner": "RENZ Online Partner",
    "privacy-terms-checkbox-html": "Ich habe die <a href=\"/service/datenschutz\" onclick=\"return openOverlay(this.href)\" >Datenschutzhinweise von RENZ</a > zur Kenntnis genommen und verstanden, dass meine personenbezogenen Daten an den von mir ausgewählten Händler übermittelt werden, damit dieser mir ein individuelles Angebot erstellen kann.",
    "send": "Absenden",
    "dealer-preselected-intro": "Die Anfrage geht an folgenden Fachhändler:",
    "customer-type": {
      "end": "Endkunde",
      "business": "gewerblicher Kunde",
      "desired-retail-partner-label": "Gewünschter Handelspartner",
      "desired-retail-partner-placeholder": "Geben Sie Ihren gewünschten Handelspartner mit Ort und Ansprechpartner an."
    },
    "dealer-preselected-login-intro": "Die Anfrage wird für folgende Händlernummer durchgeführt:"
  },
  "product": {
    "load-more": "mehr laden",
    "item-number-short": "Art. Nr.",
    "preview-not-matching-color": "Das aktuelle Vorschaubild entspricht nicht der gewählten Farbe!",
    "options": "Optionen",
    "no-option-selected": "keine Option gewählt",
    "retail-price-excl-vat": "UVP des Herstellers exkl. Mehrwertsteuer",
    "retail-price-incl-vat": "UVP des Herstellers inkl. Mehrwertsteuer",
    "choose-color": "Farbe wählen",
    "choose-color-intro-html": "Bei Renz stehen Ihnen über 200 Farben zur Auswahl, unter denen Sie sicher Ihren Wunschton finden. Die meisten Farben entstammen dem RAL-Farbregister. Hinweis: Bitte beachten Sie, dass die gezeigten Farbtöne nicht farbverbindlich sind. Für den genauen Farbton nehmen Sie bitte das RAL-Farbregister 841-GL zur Hand.",
    "search-color": "Suchen",
    "colors-with-preview": "Farben mit Vorschaubild",
    "colors-without-preview": "Farben ohne Vorschaubild",
    "back-to-overview": "zurück zur Übersicht",
    "delivery-time": "Lieferzeit",
    "working-days": "Werktage",
    "weeks": "Wochen",
    "retail-price": "UVP des Herstellers",
    "excl-vat": "exkl. Mehrwertsteuer",
    "incl-vat": "inkl. Mehrwertsteuer",
    "plus-shipping": "zzgl. Versandkosten",
    "dealer-conditions-info": "Bitte beachten Sie, dass Ihre bekannten Konditionen erst auf der Rechnung ausgewiesen werden.",
    "dealer-fixed-price-info": "Bitte beachten Sie, dass dies ein Produkt mit Festpreis ist.",
    "any-key-number": "beliebige Schlüsselnummer",
    "key-number": "Schlüsselnummer",
    "key-number-in-range-from": "Bitte hier die von Ihnen benötigte Schlüsselnummer ohne Buchstaben eintragen: im Bereich von",
    "key-number-in-range-to": "und",
    "engraving-line-1": "Gravur Zeile 1",
    "count-characters-left-html": "Noch <span class=\"num\">{count}</span> Zeichen verfügbar",
    "engraving-line-2": "Gravur Zeile 2",
    "make-inquiry": "Anfrage stellen",
    "add-to-cart": "in den Warenkorb",
    "description": "Beschreibung",
    "downloads": "Downloads",
    "quantity": "Anzahl",
    "gtin": "GTIN",
    "1-piece": "1 Stück",
    "variant": "Gebindemenge",
    "engraving-line-3": "Gravur Zeile 3"
  },
  "product-filter": {
    "material": "Material",
    "all-materials": "alle Materialien",
    "plastic": "Kunststoff",
    "aluminium": "Aluminium",
    "stainless-steel": "Edelstahl",
    "price": "Preis",
    "punch-width": "Stanzmaß Breite",
    "punch-height": "Stanzmaß Höhe",
    "outer-width": "Außenmaß Breite",
    "outer-height": "Außenmaß Höhe",
    "construction-year": "Baujahr",
    "reset-all": "Alle zurücksetzen",
    "size": "Größe",
    "color": "Farbe"
  },
  "checkout": {
    "back": "zurück",
    "next": "weiter",
    "info-and-shipping": "Informationen & Versand",
    "payment": "Zahlung",
    "summary": "Zusammenfassung",
    "order": "Bestellung",
    "thank-you-for-order": "Vielen Dank für Ihre Bestellung",
    "order-comfirmation-html": "Danke, dass Sie sich für den Renz-Shop entschieden haben. Sie erhalten in Kürze von uns eine Bestellbestätigung an Ihre hinterlegte E-Mail-Adresse.",
    "error-alert": "Es ist ein Fehler aufgetreten. Die Bestellung wurde nicht verarbeitet. Sollten Sie als Händler bestellen, prüfen Sie bitte, dass Sie das neue eInfo-Loginverfahren mit Bestellberechtigung nutzen.",
    "cart": "Warenkorb",
    "delivery-and-billing-address": "Liefer- und Rechnungsadresse",
    "dealer-number": "Händlernummer",
    "dealer-address-info-html": "Es werden die bei uns hinterlegten Adressdaten verwendet. Sollten diese Daten geändert werden, kontaktieren Sie uns bitte. Die Lieferadresse für diese Bestellung können Sie hier angeben (Drop-Shipment).",
    "further-data": "weitere Daten",
    "dealer-email-prompt": "Sie können hier eine E-Mail-Adresse eingeben, wenn Sie eine Bestellbestätigung per Email wünschen.",
    "email": "E-Mail",
    "dealer-commission-prompt": "Das nachfolgende Kommissions-Feld wird in Ihrer Bestellbestätigung hinterlegt.",
    "commission": "Kommission",
    "invoice": "Rechnung",
    "store-my-data": "Meine Bestelldaten auf diesem Rechner speichern",
    "order-now": "Jetzt zahlungspflichtig bestellen",
    "contact-data": "Kontaktdaten",
    "phone": "Telefonnummer",
    "shipping-address": "Lieferadresse",
    "firstname": "Vorname",
    "lastname": "Nachname",
    "street": "Straße",
    "house-number": "Hausnummer",
    "postcode": "PLZ",
    "city": "Ort",
    "country": "Land",
    "billing-address": "Rechnungsadresse",
    "back-to-payment": "zurück zu Zahlungsdaten",
    "paypal-error-alert": "PAYPAL FEHLER: Bitte versuchen Sie es später erneut!",
    "pay-via-invoice": "Zahlen Sie via Rechnung.",
    "paypal-language-code": "de_DE",
    "payment-type": "Zahlungsart",
    "invoice-possible-notice-html": "Kauf auf Rechnung ist nur bis zu einem Rechnungsbetrag von 500 Euro möglich.",
    "back-to-shipping": "zurück zum Versand",
    "contact-info": "Kontaktinformationen",
    "optional": "optional",
    "delivery-country-notice-html": "Bitte beachten Sie, dass wir an <b>keine Packstationen</b> und zur Zeit <b>nur innerhalb Deutschlands</b> liefern.",
    "back-to-shop": "zurück zum Shop",
    "proceed-to-payment": "weiter zur Zahlung",
    "checkout": "Kasse",
    "right-of-withdrawal-checkbox-html": "Ich habe die <a href=\"/service/widerruf\" onclick=\"return openOverlay(this.href)\" >Widerufsbelehrung</a > zur Kenntnis genommen",
    "privacy-terms-checkbox-html": "Ich habe die <a href=\"/service/datenschutz\" onclick=\"return openOverlay(this.href)\">Datenschutzerklärung</a > zur Kenntnis genommen",
    "general-terms-checkbox-html": "Ich habe die <a href=\"/service/agb\" onclick=\"return openOverlay(this.href)\" >Allgemeinen Geschäftsbedingungen</a > zur Kenntnis genommen",
    "paypal": "Paypal / Kreditkarte / Lastschrift",
    "klarna": "Klarna",
    "address-supplement": "Adresszusatz",
    "company": "Firma",
    "same-as-shipping-address": "Mit der Lieferadresse identisch",
    "different-billing-address": "Eine andere Rechnungsadresse",
    "drop-shipment-address": "Lieferadresse angeben"
  },
  "meta": {
    "description": "Renz Shop für Ersatzteile, Gravurservice und Briefkastenanlagen"
  },
  "contact-form": {
    "success": "Ihr Nachricht ist bei uns eingegangen. Wir werden Ihr Anliegen schnellstmöglich bearbeiten.",
    "error": "Es ist ein Fehler aufgetreten! Bitte versuchen Sie es später erneut.",
    "firstname": "Vorname",
    "optional": "optional",
    "lastname": "Nachname",
    "email": "E-Mail",
    "street": "Straße",
    "house-number": "Hausnummer",
    "postcode": "Postleitzahl",
    "city": "Ort",
    "subject": "Betreff",
    "message": "Nachricht",
    "file-upload": "Datei Upload",
    "send": "Absenden",
    "privacy-terms-checkbox-html": "Ich habe die <a href=\"/service/datenschutz\" onclick=\"return openOverlay(this.href)\" >Datenschutzerklärung</a > zur Kenntnis genommen",
    "phone": "Telefon"
  },
  "category": {
    "products": "Produkte",
    "sorting": "Sortierung",
    "by-name": "Name",
    "by-price-asc": "Preis ↥",
    "by-price-desc": "Preis ↧"
  },
  "service": {
    "service-area": "Servicebereich",
    "service": "Service"
  },
  "search": {
    "search-for": "Suche nach {search}",
    "search-for-html": "Produktsuche <small>nach {search}</small>",
    "count-hits": "{count} Treffer",
    "sorting": "Sortierung",
    "by-name": "nach Name sortiert",
    "by-price-asc": "Preis aufsteigend",
    "by-price-desc": "Preis absteigend"
  },
  "home": {
    "search-placeholder": "Artikelname oder Artikelnummer",
    "search": "Suchen"
  },
  "ratings": {
    "show-more": "weitere anzeigen",
    "articles": "Artikel",
    "rating": "Bewertung",
    "rating-textarea": "Schreiben Sie hier ihre Bewertung.",
    "save": "speichern",
    "saved": "Bewertung wurde gespeichert.",
    "customer-review": "Kundenrezension",
    "customer-reviews": "Kundenrezensionen",
    "processed": "Bewertung wird geprüft.",
    "ratingsname": "Name für die Bewertungen",
    "anonymous": "Anonym",
    "giveRatingError": "Bitte wählen sie eine Sternanzahl aus.",
    "already-published": "Diese Bewertung wurde bereits veröffentlicht.",
    "success": "Die Bewertung wurde erfolgreich übermittelt und wird nun geprüft. Bis zur Prüfung, können Sie die Bewertung nachträglich bearbeiten.",
    "thanks": "Vielen Dank für Ihre Bewertung",
    "rating-confirm": "Danke, dass Sie uns eine Bewertung gegeben haben. Wenn sie noch mehr Produkte bewerten möchten, so klicken sie einfach auf zurück."
  },
  "my-orders": {
    "order-details": "Bestelldetails",
    "order-intro-html": "Vielen Dank für Ihre Bestellung, nachstehend finden Sie die Einzelheiten.",
    "back-to-orders": "zurück zu meinen Bestellungen",
    "order-from-date": "Bestellung vom {date}",
    "order-number-short": "Bestell-Nr.",
    "order-number": "Bestellnummer",
    "payment-info": "Zahlungsinformationen",
    "invoice": "Rechnung",
    "contact": "Kontakt",
    "email": "E-Mail",
    "phone": "Telefonnummer",
    "firstname": "Vorname",
    "lastname": "Nachname",
    "street-and-house-number": "Straße und Hausnummer",
    "postcode": "PLZ",
    "city": "Ort",
    "country": "Land",
    "ordered-items": "bestellte Artikel",
    "item-number-short": "Art. Nr.",
    "engraving-line-1": "Gravur Zeile 1",
    "engraving-line-2": "Gravur Zeile 2",
    "key-number": "Schlüsselnummer",
    "whatever": "beliebig",
    "pieces": "Stück",
    "shipping-costs": "Versandkosten",
    "total-costs": "Gesamtpreis",
    "vat-included": "enthaltene MwSt.",
    "order-not-found": "Die Bestellung wurde nicht gefunden",
    "my-orders": "Meine Bestellungen",
    "rate-order": "Bestellung bewerten",
    "intro-html": "Hier finden Sie eine Übersicht über all Ihre Bestellungen.",
    "click-link-prompt": "Klicken Sie hier um einen neuen Link anzufordern.",
    "access-denied": "Zugriff verweigert!",
    "link-is-invalid": "Der Link ist nicht mehr gültig.",
    "view-order": "Bestellung ansehen",
    "no-order-for-email-html": "Zu Ihrer E-Mail-Adresse wurden bisher keine Bestellungen in unserem System gespeichert.",
    "load-more": "mehr laden",
    "error": "Es ist ein Fehler aufgetreten! Bitte versuchen Sie es später erneut.",
    "not-found": "Es wurde keine passende Bestellung gefunden. Haben sie sich vertippt?",
    "link-request-intro-html": "Wenn Sie bereits eine Bestellung getätigt haben, können Sie sich hier mit der verwendeten E-Mail-Adresse Ihre Bestell-Historie anschauen.",
    "link-request-success": "Der Link wurde Ihnen per Email zugesendet. Bitte prüfen Sie Ihr Email-Postfach und ggf. Ihrem Spamordner.",
    "send-link": "Bestellungs-Link zusenden",
    "send": "absenden",
    "packaging-costs": "Verpackungskosten",
    "engraving-line-3": "Gravur Zeile 3"
  },
  "not-found": {
    "site-not-found": "Die Seite wurde nicht gefunden"
  },
  "product-config": {
    "configurator": "Konfigurator",
    "reset-all": "Alle Filter löschen",
    "back": "zurück",
    "next": "weiter",
    "select-not-included": "Ihre Auswahl nicht dabei?",
    "item-number-short": "Art. Nr.",
    "more-details": "mehr Details",
    "retail-price": "UVP des Herstellers",
    "excl-vat": "exkl. Mehrwertsteuer",
    "incl-vat": "inkl. Mehrwertsteuer",
    "make-inquiry": "Anfrage stellen"
  },
  "klarna": {
    "error": "Es ist ein Fehler aufgetreten! Bitte versuchen Sie es noch einmal.",
    "order_now": "Jetzt bestellen und zahlen mit Klarna",
    "proceed": "weiter mit Klarna"
  },
  "paypal": {
    "order_now": "Jetzt zahlen und bestellen mit"
  },
  "offer-assistant": {
    "title": "Konfigurator",
    "ok": "Ok",
    "close": "Konfigurator verlassen",
    "welcome-title": "Willkommen im Konfigurator",
    "welcome-text": "Hier bieten wir Ihnen die Möglichkeit Ihre Briefkastenanlage im Detail zu konfigurieren.<br/>Bearbeiten Sie hierzu die Schritte nacheinander und wählen Sie die gewünschten Merkmale aus.<br/>Nach dem Abschluss erhalten Sie in Kürze ein ausführliches Angebot inkl. Ausschreibungstext, technischer Zeichnung und fotorealistischer Ansicht."
  },
  "error": "Fehler"
}
